import { useEffect } from 'react';
import { useSocketStore } from '../../stores/useSocketStore';

const subscriptions = new Map();

export function useChegadasRoom(codigo) {

    const socket = useSocketStore(state => state.socket);

    useEffect(() => {

        if (!socket || !codigo) {
            return;
        }

        const key = String(codigo).trim();

        if (!key) {
            return;
        }

        const count = subscriptions.get(key) || 0;

        const handleConnect = () => {

            // Essa room ainda possui algum consumidor?
            if ((subscriptions.get(key) || 0) > 0) {
                socket.emit(
                    'chegadas-viagens:join',
                    key
                );
            }

        };

        socket.on('connect', handleConnect);

        if (count === 0 && socket.connected) {
            socket.emit(
                'chegadas-viagens:join',
                key
            );
        }

        subscriptions.set(key, count + 1);

        return () => {

            socket.off('connect', handleConnect);

            const nextCount =
                (subscriptions.get(key) || 1) - 1;

            if (nextCount <= 0) {

                if (socket.connected) {
                    socket.emit(
                        'chegadas-viagens:leave',
                        key
                    );
                }

                subscriptions.delete(key);

            } else {

                subscriptions.set(key, nextCount);

            }

        };

    }, [socket, codigo]);

}